import Vue from "vue";
import VueI18n, { NumberFormats } from "vue-i18n";
import { getLocale } from "@/lib/localeHelper";

Vue.use(VueI18n);

interface Locale {
  [k: string]: string | Locale;
}

function loadLocaleMessages() {
  const locales = require.context("@/locales/messages", false, /[A-Za-z0-9-_,\s]+\.ts$/i);
  const locations = require.context("@/locales/locations", false, /[A-Za-z0-9-_,\s]+\.ts$/i);
  const messages: { [k: string]: Locale } = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale: string = matched[1];
      messages[locale] = locales(key).default;
      const locationKey = key.replace(".json", ".ts");
      if (locations.keys().indexOf(locationKey) > -1) {
        messages[locale] = {
          ...messages[locale],
          $locations: locations(locationKey).default,
        };
      }
    }
  });

  return messages;
}

function numberFormats() {
  const locales: NumberFormats = {
    en: {
      currency: {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  };
  return locales;
}

const I18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  numberFormats: numberFormats(),
  messages: loadLocaleMessages(),
  formatFallbackMessages: true,
  silentTranslationWarn: process.env.VUE_APP_I18N_SILENT === "true",
});

export default I18n;
